import { useState } from 'react';
import axios from 'axios';
import { Button } from '../../components/ui/button';
import { Settings2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// LLMDiagnosticPanel — verify the active LLM provider (Emergent vs google-genai)
const LLMDiagnosticPanel = () => {
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);

  const runCheck = async () => {
    setRunning(true);
    setResult(null);
    try {
      const r = await axios.get(`${API}/admin/llm-diagnostic`, { withCredentials: true });
      setResult(r.data);
    } catch (e) {
      setResult({ error: e.response?.data?.detail || 'Erreur diagnostic' });
    } finally {
      setRunning(false);
    }
  };

  const providerColor = (p) => {
    if (p === 'google_genai') return 'bg-emerald-100 text-emerald-700 border-emerald-200';
    if (p === 'emergent') return 'bg-blue-100 text-blue-700 border-blue-200';
    return 'bg-red-100 text-red-700 border-red-200';
  };

  return (
    <div className="mb-6 p-4 rounded-lg border border-gray-200 bg-white" data-testid="llm-diagnostic-panel">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-3">
        <div>
          <h3 className="font-semibold text-gray-900 text-sm flex items-center gap-2">
            <Settings2 className="w-4 h-4 text-blue-600" />
            LLM Provider — Diagnostic
          </h3>
          <p className="text-xs text-gray-500 mt-0.5">
            Vérifier si Gemini Vision répond via la clé `GOOGLE_API_KEY` (ou retombe sur Emergent).
          </p>
        </div>
        <Button
          onClick={runCheck}
          disabled={running}
          variant="outline"
          className="text-xs"
          data-testid="llm-diagnostic-run"
        >
          {running ? 'Test en cours…' : 'Lancer le test'}
        </Button>
      </div>
      {result && (
        <div className="mt-3 p-3 rounded bg-gray-50 border border-gray-100 text-xs space-y-1.5" data-testid="llm-diagnostic-result">
          {result.error && <p className="text-red-600 font-medium">⚠ {result.error}</p>}
          {!result.error && (
            <>
              <div className="flex items-center gap-2">
                <span className="text-gray-500">Provider actif :</span>
                <span className={`px-2 py-0.5 rounded-full font-bold uppercase tracking-widest text-[10px] border ${providerColor(result.active_provider)}`}>
                  {result.active_provider}
                </span>
              </div>
              <p><span className="text-gray-500">GOOGLE_API_KEY :</span> {result.google_api_key_present ? '✅ présent' : '❌ absent'}</p>
              <p><span className="text-gray-500">EMERGENT_LLM_KEY :</span> {result.emergent_llm_key_present ? '✅ présent' : '❌ absent'}</p>
              <p>
                <span className="text-gray-500">Test vision :</span>{' '}
                {result.test_status === 'ok' && <span className="text-emerald-600 font-medium">✅ OK ({result.test_response_chars} chars)</span>}
                {result.test_status === 'failed' && <span className="text-red-600 font-medium">❌ {result.test_error}</span>}
                {result.test_status === 'skipped' && <span className="text-gray-500">(skipped)</span>}
                {result.test_status === 'no_provider' && <span className="text-amber-600">aucun provider configuré</span>}
              </p>
              {result.test_response_preview && (
                <p className="text-gray-500 italic">"{result.test_response_preview}"</p>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default LLMDiagnosticPanel;
